import _jsx from '@babel/runtime/helpers/esm/jsx';
import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useMakeSelect } from '@dbh/reselect-extra';
import SmartSection from '@dbh/smart-section';
import { makeSelectWebcontrolsLoaded, makeSelectWebcontrolByReference } from '@dbh/webcontrols-redux';

const CitiesTilesSectionContainer=/*#__PURE__*/memo(()=>{const a=useMakeSelect(makeSelectWebcontrolsLoaded),b=useSelector(useMemo(()=>makeSelectWebcontrolByReference("CityTiles"),[]));return a&&b?/*#__PURE__*/_jsx(SmartSection,{elements:b.get("elements"),title:b.get("headingText"),htmlTag:b.get("htmlTag"),buttonsVisible:!1}):null});CitiesTilesSectionContainer.displayName="CitiesTilesSectionContainer";

export { CitiesTilesSectionContainer as default };
